import React from 'react';
import Head from 'next/head';

function PlausibleProvider(props) {
    var _a = props.customDomain, customDomain = _a === void 0 ? 'https://plausible.io' : _a, _b = props.enabled, enabled = _b === void 0 ? process.env.NODE_ENV === 'production' : _b;
    return (React.createElement(React.Fragment, null,
        React.createElement(Head, null, enabled && (React.createElement("script", { async: true, defer: true, "data-domain": props.domain, "data-exclude": props.exclude, src: customDomain + "/js/" + (props.selfHosted || customDomain === 'https://plausible.io'
                ? 'plausible'
                : 'index') + (props.trackOutboundLinks ? '.outbound-links' : '') + (props.exclude ? '.exclusions' : '') + ".js", integrity: props.integrity, crossOrigin: props.integrity ? 'anonymous' : undefined }))),
        props.children));
}
function usePlausible() {
    return function (eventName) {
        var _a, _b;
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        return (_b = (_a = window).plausible) === null || _b === void 0 ? void 0 : _b.call(_a, eventName, rest[0]);
    };
}

export default PlausibleProvider;
export { usePlausible };
//# sourceMappingURL=index.esm.js.map
